import styles from "./dot.module.css"

// Dot component
export function Dot({
  rowIndex,
  colIndex,
  randomIndex
}: {
  rowIndex: number
  colIndex: number
  randomIndex: number
}) {
  return (
    <div className={styles["container"]}>
      <div
        className={`dot ${styles["dot"]}`}
        id={`r${rowIndex}c${colIndex}`}
        random-index={randomIndex}
      />
    </div>
  )
}
